export const loaderServiceOptions = {
  lock: true,
    text: 'Please wait, opening a large trace file can be slow...',
  spinner: 'el-icon-loading',
  // background: 'rgba(0, 0, 0, 0.7)'
}